import { Component, OnInit, ViewChild } from '@angular/core';
import { GraphviewService } from '../graphview/graphview.service';
import { UIChart } from 'primeng/chart';
import { ConnectableObservable } from 'rxjs';
import csvDownload from 'json-to-csv-export'

@Component({
    selector: 'app-graphview',
    templateUrl: './graphview.component.html',
    styleUrls: ['./graphview.component.css'],
    standalone: false
})
export class GraphviewComponent implements OnInit {
  @ViewChild("chart", { static: true }) chart: UIChart;
  cdata: any;
  ctitle: string;
  visible: boolean = false;
  seltype: any;
  seltypes: any[] = [{ label: "linijski", value: "line" }, { label: "stolpični", value: "bar" }];
  sDate: Date = new Date();
  eDate: Date = new Date();
  graphRequestData: any = null;
  nodata: boolean = true;
  
  constructor(private gvs: GraphviewService) {
    this.cdata = {
      labels: [],
      datasets: []
    };
    this.seltype = this.seltypes[0].value;
    this.sDate.setDate(this.sDate.getDate() - 1);
  }

  public selectData(e: any) {
    console.log(e);
  }
  public chGraphType(e) {
    this.chart.type = e.value;
    this.chart.reinit();
  }

  public selectFromDate(e) {
    console.log("From Date", e)
    this.checkDates();

  }

  public selectToDate(e) {
    console.log("To Date", e)

    this.checkDates();

  }


  private checkDates() {
    if (this.sDate.getTime() > this.eDate.getTime())
      this.sDate = this.eDate;

    this.filterGraph();
  }

  public hasTimeFilter(): boolean {
    return this.graphRequestData !== null && this.graphRequestData.showDateTimePicker !== undefined

  }

  private filterGraph() {
    console.log(this.graphRequestData);
    Object.assign(this.graphRequestData, { filter: { startDate: this.sDate, endDate: this.eDate } });
    this.gvs.getGraphData(this.graphRequestData).subscribe(gd => {
      console.log("get data set:");
      console.log(gd);
      this.gvs.setData(gd, this.graphRequestData.chartType, this.graphRequestData.chartType.chartName, this.graphRequestData);

    });

  }


  ngOnInit() {
    this.gvs.subscribe().subscribe(d => {
      console.log("chart data and type input:");
      console.log(d);
      this.visible = true;
      this.chart.data = { labels: [], datasets: [] };
      
      this.graphRequestData = d.requestdata;

      if (this.hasTimeFilter()) {
        this.sDate = new Date(Date.parse(this.graphRequestData.filter.startDate));
        this.eDate = new Date(Date.parse(this.graphRequestData.filter.endDate));
      }
      setTimeout(() => {

        this.chart.data = d.data;
        this.chart.type = this.seltype;
        this.ctitle = d.title;
        this.chart.reinit();

      }, 500);
      if(!d.data.datasets) {
        d.data = { labels: [], datasets: [] };
        return
      }
      var dataarray = d.data.datasets.filter(c => c.data !== null);

      if (dataarray.length === 0) {
        d.data = { labels: [], datasets: [] };
        this.nodata = true;
      }
      else {
        this.nodata = false;
      }
      //this.chart.reinit();
     
      this.cdata = dataarray;
    })
  }

  exportCsv() {
    this.gvs.getCsvData(this.graphRequestData).subscribe(csvData => {
      // console.log(csvData)
      csvDownload(csvData, `${this.ctitle}_${new Date().toISOString().split('T')[0]}.csv`, ";")
    })

  }
}
